import { render, staticRenderFns } from "./TemplateCreatorDragAndDrop.vue?vue&type=template&id=42bd47d2&scoped=true&"
import script from "./TemplateCreatorDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./TemplateCreatorDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCreatorDragAndDrop.vue?vue&type=style&index=0&id=42bd47d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd47d2",
  null
  
)

export default component.exports